import { GridDimension } from "client/Api/Workspace/common";
import { ReactElement } from "react";
import { areDimensionsEqual, DimensionToRender } from "./RenderState/common";

export type RenderFactory = () => ReactElement;

export function useRenderManager(
	dimension: DimensionToRender,
	standard: RenderFactory,
	...alternatives: readonly [dimension: GridDimension, renderer: RenderFactory][]
): ReactElement {
	let factoryToUse: RenderFactory = standard;

	if (dimension.kind !== "responsive") {
		for (const alternative of alternatives) {
			if (areDimensionsEqual(alternative[0], dimension.dimension)) {
				factoryToUse = alternative[1];
				break;
			}
		}
	}

	return factoryToUse();
}
